import React from 'react'
import seemore from "../Assets/images/see-more.png"

const SeeMore = ({ title, icon = true, onClick }) => {
    return (
        <div onClick={onClick ? onClick : null} className='d-flex gap-2'>
            <span className="themeBlueV2 cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>{title}</span>
            {icon && <img style={{ marginTop: "7px" }} width={5} height={9} src={seemore} alt="seemore" />}
        </div>
    )
}

export default SeeMore